import type {Service} from "@project/application/engineering/services";

import {getServiceQueryOptions} from "@project/application/engineering/services";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {z} from "zod";

import {routeMessages} from "../../../../../messages/routes.messages";

import {ServicePage} from "./-page/service.page";
import {ServicePending} from "./-page/service.pending";

const serviceSearchSchema = z.object({includeDeleted: z.boolean().default(false)});

export const Route = createFileRoute("/_app/engineering/services/$serviceId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  validateSearch: serviceSearchSchema,
  loaderDeps: ({search}) => ({includeDeleted: search.includeDeleted}),
  loader: async ({context: {queryClient}, deps, params}) =>
    queryClient.ensureQueryData(getServiceQueryOptions(params.serviceId, deps.includeDeleted)),
  pendingComponent: ServicePending,
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) => (data as Service | undefined)?.name,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.serviceById.id,
        values: {serviceId: p["serviceId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {serviceId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <ServicePage serviceId={serviceId} includeDeleted={includeDeleted} />;
}
